<template>
    <div> 
        <ul v-if="task_type_id >= 2 && task_type_id <= 6">
            <li v-for="(answer,index) in myAnswers" :key="index">
                {{ answer }}
            </li>                                
        </ul>
        <div v-if="task_type_id == 7">
            <div v-for="(answer,index) in myAnswers" :key="index" v-html="answer"></div>
        </div>
        <div v-if="task_type_id >=8 && task_type_id <=10 && myAnswers.length > 0">
            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                <v-tab v-for="(answer, index) in myAnswers" :key="index" @click="tabIndex = index">
                    {{answer.filename}}
                </v-tab>
                <v-spacer></v-spacer>
                <v-icon large style="cursor:pointer" title="Evaluate" @click="evaluate()">done</v-icon>
            </v-tabs>
            <codemirror  class="border-top" 
                v-model="myAnswers[tabIndex].filecontent" 
                :options="getCmOptions(false)"
            />
        </div>
        <div v-if="(task_type_id == 16) && myAnswers.length > 0">
            <v-row>
                <v-col cols="7">
                    <v-textarea 
                        label="Answer:"
                        readonly
                        v-model="myAnswers[0]" 
                        rows="8"
                        outlined
                    />
                </v-col>
                
                <v-col cols="5">
                    <v-row>
                        <v-col cols="9">
                            <v-slider
                                min="0"
                                :max="maxScore"
                                v-model="score"                               
                                thumb-label="always"                                
                                ></v-slider>
                        </v-col>
                        <v-col cols="3">
                            <v-btn @click="saveCommentsAndScoreToAttempt()">Save</v-btn>
                        </v-col>
                    </v-row><v-row>
                        <v-col cols="12">
                            <v-textarea 
                                label="Teacher comment:"
                                v-model="myComment" 
                                rows="5"
                                outlined
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <div v-if="(task_type_id == 17) && myAnswers.length > 0">
        <v-row>
            <v-col cols="7">
            <v-card outlined>
                <v-card-title class="py-2">
                <span class="subtitle-2">GenAI discussion</span>
                <v-spacer></v-spacer>

                <v-btn icon small :disabled="stepIndex <= 0" @click="prevStep">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <span class="caption mx-2">
                    Step {{ stepIndex + 1 }} / {{ genaiSteps.length }}
                </span>

                <v-btn icon small :disabled="stepIndex >= genaiSteps.length - 1" @click="nextStep">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                </v-card-title>

                <v-divider />

                <!-- fixná výška, scrolluje sa obsah prompt/reply/reflection -->
                <v-card-text class="genai-scroll">
                <div v-if="genaiSteps.length > 0">
                    <div class="subtitle-2 mb-1">Prompt</div>
                    <div class="prelike">{{ genaiSteps[stepIndex].prompt }}</div>

                    <v-divider class="my-3" />

                    <div class="subtitle-2 mb-1">GenAI reply</div>
                    <div class="ql-output" v-html="genaiSteps[stepIndex].replyHtml"></div>

                    <v-divider class="my-3" />

                    <div class="subtitle-2 mb-1">Reflection</div>
                    <div class="prelike">{{ genaiSteps[stepIndex].reflection }}</div>
                </div>

                <div v-else class="caption grey--text">
                    No steps found in this attempt.
                </div>
                </v-card-text>
            </v-card>
            </v-col>

            <!-- pravý stĺpec (hodnotenie + komentár) nechaj rovnaký -->
            <v-col cols="5">
            <v-row>
                <v-col cols="9">
                <v-slider
                    min="0"
                    :max="maxScore"
                    v-model="score"
                    thumb-label="always"
                ></v-slider>
                </v-col>
                <v-col cols="3">
                <v-btn @click="saveCommentsAndScoreToAttempt()">Save</v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                <v-textarea
                    label="Teacher comment:"
                    v-model="myComment"
                    rows="5"
                    outlined
                />
                </v-col>
            </v-row>
            </v-col>
        </v-row>
        </div>
    </div>
</template>

<script>

import { codemirror } from "vue-codemirror";
import * as es from "../../assets/editor_settings.js";
import axios from '../,,/../../axios-auth.js'

export default {
    data() {
        return {
            taskContent: {},
            taskOptions: [],
            tabIndex: 0,
            score: 5,
            myComment: '',
            genaiSteps: [],     // [{prompt, replyHtml, reflection}]
            stepIndex: 0,       // aktuálny krok
        }
    },
    watch: {
        myInfo() {
            this.myComment = this.myInfo
            console.log('aktualizujem')
        },
        curScore() {
            this.score = this.curScore
        },
        myAnswers: {
            handler() {
                if (this.task_type_id === 17) this.parseGenAiSteps()
            },
            deep: true
            },
        task_type_id(val) {
            if (val === 17) this.parseGenAiSteps()
        },

    },
    props: {
        task_type_id: Number,
        myAnswers: Array,
        myCode: String,
        myInfo: {type: String, required: true},
        maxScore: Number,
        curScore: {type: Number, required: true},
        attID: Number
    },
    components: {
        codemirror
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.score = this.curScore
            this.myComment = this.myInfo
            if (this.task_type_id === 17) this.parseGenAiSteps()
        },
        getCmOptions(_readOnly, _lines = 1, _line_numbers = true) {
            return es.getCmOptionsLines(
                "text/x-python",
                _readOnly,
                _lines,
                _line_numbers
            );
        },
        evaluate()  {
            // console.log(this.myNewAnswers[this.tabIndex].filecontent)
        },
        saveCommentsAndScoreToAttempt() { // for type 16
            // all students lessons
            let _data = {
                attempt_id: this.attID,
                score: this.score,
                comment: this.myComment
            }

            this.$store.commit('setEssayReviewData', _data)
            this.$store.commit('setEssayReviewChanged', true)
        },
        parseGenAiSteps() {
        this.stepIndex = 0
        this.genaiSteps = []

        let raw = (this.myAnswers && this.myAnswers.length > 0) ? this.myAnswers[0] : ''
        if (!raw) return

        // myAnswers[0] môže byť priamo objekt alebo string
        let candidate = raw

        // 1) ak príde ako JSON pole stringov: ["{...}"]
        if (typeof candidate === 'string') {
            try {
            const arr = JSON.parse(candidate)
            if (Array.isArray(arr) && arr.length > 0 && typeof arr[0] === 'string') {
                candidate = arr[0]
            }
            } catch (_) {}
        }

        // 2) ak je to JSON objekt s _content
        try {
            const obj = (typeof candidate === 'string') ? JSON.parse(candidate) : candidate
            if (obj && Array.isArray(obj._content)) {
            this.genaiSteps = obj._content.map(it => ({
                prompt: (it.prompt || '').toString(),
                replyHtml: (it.reply || '').toString(),      // HTML z Quill
                reflection: (it.reflection || '').toString()
            }))
            return
            }
        } catch (_) {}

        // fallback: aspoň jeden krok
        this.genaiSteps = [{
            prompt: (candidate || '').toString(),
            replyHtml: '',
            reflection: ''
        }]
        },

        prevStep() {
        if (this.stepIndex > 0) this.stepIndex -= 1
        },
        nextStep() {
        if (this.stepIndex < this.genaiSteps.length - 1) this.stepIndex += 1
        },

    }
}
</script>
<style scoped>
    .genai-scroll {
    max-height: 200px;
    overflow-y: auto;
    }

    .prelike {
    white-space: pre-wrap;
    word-break: break-word;
    }

    /* aby HTML z Quillu vyzeral normálne */
    .ql-output :deep(p) { margin: 0 0 .5rem 0; }
    .ql-output :deep(ul), .ql-output :deep(ol) { padding-left: 1.2rem; margin: .25rem 0; }
</style>
